/**
 * RequestForm Component
 *
 * Wrapper around DynamicFormGroup for sponsor advisory request form
 * Handles form data collection and submission
 */

import React, { useRef, useEffect } from 'react';

import DynamicFormGroup from 'components/DynamicFormGroup';
import { AggregatedFormData } from 'components/DynamicFormGroup/types/formTypes';

interface RequestFormProps {
  formGroupId: string;
  onFormDataReady?: (hasData: boolean) => void;
}

const RequestForm: React.FC<RequestFormProps> = ({ formGroupId, onFormDataReady }) => {
  // The DynamicFormGroup will automatically handle:
  // - Fetching form structure from backend (group_id: "sponsor-advisory-form")
  // - Rendering appropriate field components
  // - Auto-saving field data to backend
  // - Loading previously saved data for the user
  const formDataRef = useRef<AggregatedFormData | null>(null);

  useEffect(() => {
    if (formDataRef.current && onFormDataReady) {
      // Check if all required fields have been filled
      const requiredFields = formDataRef.current.forms.flatMap(form =>
        form.fields.filter(field => field.is_required)
      );
      const allFieldsFilled = requiredFields.every(
        field => field.submission && field.submission.values && field.submission.values.length > 0
      );
      if (allFieldsFilled) {
        onFormDataReady(true);
      }
    }
  }, [onFormDataReady]);

  return (
    <div>
      <DynamicFormGroup group_id={formGroupId} formDataRef={formDataRef} />
    </div>
  );
};

export default RequestForm;
